(function () {
    'use strict';

    angular.module('swif.interventions')

        .service('ganttService', ganttService);

    function ganttService(swif, interventionService, interventionsPlanningService) {
        'ngInject';

        var service = {};

        service.TASKS_FIELDS = interventionsPlanningService.TASKS_FIELDS;
        service.INTERVENTIONS_PAGE_LIMIT = 10;

        service.resolveData = function () {
            var data = {};
            return swif.settings.initialize()
                .then(function () {
                    data.debug = swif.route.debug;
                    data.title = 'Gantt';
                    data.project_type = 'intervention';
                    return service.createInterventions();
                }).then(function (interventionsCollection) {
                    data.interventions = interventionsCollection;
                    interventionService.currentCollection = interventionsCollection;
                    return service.createTasks(interventionsCollection)
                }).then(function () {
                    return data;
                })
        };

        // we use planning-interventions and planning-tasks names in gantt
        // so we can reuse callback methods (preValidateTask, etc)
        service.getInterventionsCollection = function () {
            return swif.collections.getCollection('planning-interventions');
        };

        service.getTasksCollection = function () {
            return swif.collections.getCollection('planning-tasks');
        };

        service.createInterventions = function () {
            var filter = {};
            swif.data.addFilter(filter, 'state', 'in', ['scheduled', 'pending', 'open']);
            swif.data.sortOn(filter, 'id', 'DESC');
            swif.data.setLimit(filter, service.INTERVENTIONS_PAGE_LIMIT);
            filter.fields = interventionService.COLLECTION_FIELDS;
            return swif.collections.createOrUpdate(
                'planning-interventions',
                'intervention',
                filter,
                {limitPerPage: service.INTERVENTIONS_PAGE_LIMIT}
            );
        };

        service.updateInterventions = function (filter) {
            swif.data.setLimit(filter, service.INTERVENTIONS_PAGE_LIMIT);
            filter.fields = interventionService.COLLECTION_FIELDS;
            return swif.collections.createOrUpdate(
                'planning-interventions',
                'intervention',
                filter,
                {limitPerPage: service.INTERVENTIONS_PAGE_LIMIT}
            );
        };

        /* Update collection with tasks of interventions */
        service.createTasks = function (interventions) {
            var interventionsIds;
            if (interventions.items.length) {
                interventionsIds = _.pluck(interventions.items, 'id');
            } else {
                interventionsIds = ['--noValue--'];  // odoo api breaks if value for extra filter is empty ([])
            }
            var filter = {
                fields: service.TASKS_FIELDS,
                limit: 0,
            };
            swif.data.addExtraFilter(filter, 'gantt', 'project_id', 'in', interventionsIds);
            return swif.collection.createOrUpdate('planning-tasks', 'task', filter);
        };

        return service;
    }

})();
